import React, { useRef, useState, useContext, useEffect } from "react";
import "./App.css";
//import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  unstable_HistoryRouter as Router,
} from "react-router-dom";
import { useEffectOnce } from "./hooks/useEffectOnce";
import { distributionService } from "./services/distributionService";
import { directionService } from "./services/directionService";
import customhistory from "./history/customhistory";
import LoggerContext from "./context/LoggerProvider";
import { DirectionProvider } from "@radix-ui/react-direction";
import { PresListProvider } from "./context/PresListProvider";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import RoutesWithHeader from "./components/RoutesWithHeader";

export const WSContext = React.createContext();

function App() {
  const [socket, setSocket] = useState(null);
  const [roomId, setRoomId] = useState(0);
  const [listRefresh, setListRefresh] = useState(false);
  const [shadcnDirection, setShadcnDirection] = useState(document.body.dir);

  const [globalAbortController, setGlobalAbortController] = useState(
    new AbortController()
  );

  const { Logger } = useContext(LoggerContext);
  const ws = useRef();
  const roomRef = useRef(null);

  useEffectOnce(() => {
    // unset semaphore
    sessionStorage.removeItem("semaphore");

    // chat server connection, get current host
    Logger.debug("process.env", process.env);
    let host = window.location.host;
    let origin = window.location.origin;
    if (host.indexOf("localhost:3") !== -1)
      host = "ws://" + host.split(":")[0] + ":8080";
    else if (origin.indexOf("https:") !== -1)
      host = "wss://" + process.env.REACT_APP_API_BASE.split("//").pop();
    else host = "ws://" + host;
    host += "/api/websocket";

    Logger.info("Connecting to chat server on host " + host);
    ws.current = new WebSocket(host);

    setSocket(ws.current);

    ws.current.onopen = () => {
      Logger.info("Chat connection opened");

      // was it a page refresh but email/accessToken are still in localStorage? Then send "login" to websocket
      const storedAuthJson = localStorage.getItem("auth") ?? "{}";
      const storedAuth = JSON.parse(storedAuthJson);
      let emailAddress = storedAuth.email;
      if (emailAddress) {
        ws.current.send(
          JSON.stringify({
            command: "login",
            payload: {
              email: emailAddress,
            },
          })
        );
      }
    };

    ws.current.onmessage = (e) => {
      const msg = JSON.parse(e.data);
      Logger.info(
        "Chat message received ... distributing to listening components",
        msg
      );

      if (msg.command === "userlist")
        distributionService.sendUserlist(msg.payload);
      else distributionService.sendMessage(msg);
    };

    let directionUnsubscribe = directionService
      .getDirectionChange()
      .subscribe(() => {
        setShadcnDirection(document.body.dir);
      });

    return () => {
      Logger.error("UNLOADING App.js ... normally this should not happen!");
      Logger.info("Chat close connection");
      ws.current.close();
      directionUnsubscribe.unsubscribe();
    };
  }, []);

  useEffect(() => {
    roomRef.current = roomId;
  }, [roomId]);

  return (
    <div className="text-black h-screen w-full flex flex-col">
      <WSContext.Provider
        value={{
          socket,
          roomId,
          setRoomId,
          roomRef,
          listRefresh,
          setListRefresh,
          globalAbortController,
          setGlobalAbortController,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <DirectionProvider dir={shadcnDirection}>
            <PresListProvider>
              <Router history={customhistory}>
                <RoutesWithHeader />
              </Router>
            </PresListProvider>
          </DirectionProvider>
        </QueryClientProvider>
      </WSContext.Provider>
    </div>
  );
}

export default App;
